var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrownSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.635 2.72167C9.67097 2.65634 9.72381 2.60186 9.78801 2.56392C9.85222 2.52598 9.92543 2.50596 10 2.50596C10.0746 2.50596 10.1478 2.52598 10.212 2.56392C10.2762 2.60186 10.329 2.65634 10.365 2.72167L12.825 7.39167C12.8837 7.4998 12.9655 7.59361 13.0648 7.66635C13.164 7.73909 13.2781 7.78896 13.3988 7.81238C13.5196 7.8358 13.6441 7.8322 13.7633 7.80181C13.8825 7.77143 13.9935 7.71503 14.0883 7.63667L17.6525 4.58333C17.7209 4.52768 17.8052 4.49518 17.8933 4.4905C17.9814 4.48582 18.0687 4.50921 18.1426 4.55729C18.2165 4.60537 18.2733 4.67567 18.3047 4.75808C18.3361 4.84048 18.3406 4.93073 18.3175 5.01583L15.9558 13.5542C15.9076 13.7289 15.8038 13.8831 15.66 13.9935C15.5162 14.1039 15.3404 14.1644 15.1592 14.1658H4.84167C4.66028 14.1646 4.48426 14.1042 4.34033 13.9938C4.19639 13.8834 4.09241 13.729 4.04417 13.5542L1.68333 5.01667C1.66021 4.93156 1.66468 4.84131 1.69612 4.75891C1.72755 4.67651 1.78432 4.60621 1.85825 4.55812C1.93218 4.51004 2.01946 4.48665 2.10753 4.49133C2.1956 4.49601 2.27991 4.52852 2.34833 4.58417L5.91167 7.6375C6.0065 7.71587 6.11751 7.77227 6.23672 7.80265C6.35593 7.83303 6.48039 7.83664 6.60117 7.81322C6.72194 7.78979 6.83603 7.73992 6.93524 7.66718C7.03446 7.59444 7.11634 7.50064 7.175 7.3925L9.635 2.72167Z",
    stroke: "#C7CCD6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.16667 17.5H15.8333",
    stroke: "#C7CCD6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrownSilver);
export default __webpack_public_path__ + "static/media/crown_silver.bb700b6a0adfd556f5f54978aa9649b9.svg";
export { ForwardRef as ReactComponent };